import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { NoItemsDisclaimerComponent } from '../no-items-disclaimer/no-items-disclaimer.component';
import { PaymentConfirmation } from '../../shared/models/make-payment.model';
import { InvoiceUtils } from '../../shared/utils/invoice.utils';
import { PaymentsConfirmationInvoicesListRowComponent } from '../payments-confirmation-invoices-list-row/payments-confirmation-invoices-list-row.component';

@Component({
  selector: 'sanofi-payments-confirmation-invoices-list',
  standalone: true,
  imports: [
    I18nModule,
    NoItemsDisclaimerComponent,
    PaymentsConfirmationInvoicesListRowComponent
  ],
  templateUrl: './payments-confirmation-invoices-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentsConfirmationInvoicesListComponent {
  protected readonly InvoiceUtils = InvoiceUtils;
  paymentResponse = input.required<PaymentConfirmation>();
}
